<template>
	<div>
		<div v-if="this.product" class="box link" style="" @click.stop="showProductDetails();" :title="this.title" @mouseleave="this.startCloseBuyPopoverTimer()">
			<div class="boxHeader">HEADER</div>
			<div v-if="this.canFavorite && this.canHover && (this.over || this.favorite)" class="flexcenter"
				@click.stop="this.toggleFavorite(this.productId)" style="position: absolute; top:10px;margin-left:10px;">
				<Circle :fileName="this.favorite ? 'w3_bookmark_solid_grey' : 'w3_bookmark_dark' " color="--grey-1" hover=""
					padding="25%" />

			</div>
			<ProductCellImageSquare :filename="this.filename" style="width:calc(100% - 2px);" :parentTitle="this.title"
				@mouseenter="this.over = true;" @mouseleave="this.over = false" />



			<div class="boxContent">
				<div class="flexcenter" style="">
					<b class="font-smallest" style="color:var(--font-color-grey);cursor:initial;"
						title="Klicka för att kopiera artikelnummer"
						@click.stop="this.copyArtNr(this.formatArtnr(this.product.artnr))">{{ this.formatArtnr(this.product.artnr)
						}}</b>
					<!-- kopierad - icon -->
					<transition name="fade">
						<Circle v-if="this.showCopied" size="10px" color="--bg-ok-light" fileName="w3_check_white" />
					</transition>
				</div>
				<b style="font-size:90%;">{{ this.product.manufactorName }}</b> <span style="font-size:90%;">{{
					this.product.name }}</span>

			</div>
			<div class="boxSpacer"></div>
			<div class="flexcenter" style="width:100%;">
				<div v-if="this.stockModel" class="flexcenter" style="margin-left:0px;">

					<!-- dot vid lagersaldo -->
					<div style="height:10px;min-width:10px;width:10px;border-radius: 5px;margin-right:3px;"
						:class="'stock_' + this.stockModel?.key"></div>
					<div class="font-smaller"><b style="color:var(--font-color-grey-light);" :title="this.stockModel?.label">{{
							this.stockModel?.labelShort }}</b></div>
				</div>
				<div style="flex-grow:1;min-width:0px;"></div>
				<div class="boxPrice" style="margin-right:5px;">
					<b style="font-size: 110%;" :class="this.outlet ? 'outlet-price' : ''">{{
						this.formatPrice(this.product) }}</b>
				</div>


				<!-- köpknapp -->
				<div id="buyButtonWrapper" v-if="this.isLoggedIn" class="desktop">

					<div
						style="background:var(--bg-message);color:white;padding:5px;border-radius:5px;font-weight: bold;padding-left:10px;padding-right:10px;"
						class="font-smaller flexcenter" @click.stop="this.showBuyPopover = !this.showBuyPopover">
						KÖP
						<Icon :fileName="this.showBuyPopover ? 'w3_chevron_up_white' : 'w3_chevron_down_white' "
							style="margin-left:3px;width:12px;height:12px;margin-right:0px;" />
					</div>

					<!-- productOptionList dropdown -->
					<div v-if="this.showBuyPopover" ref="productOptionPopover" class="productOptionPopover drop-shadow-light"
						:class="{ alignRight: alignRight }" @mouseleave="this.showBuyPopover = false"
						style="overflow:scroll;min-height:100px;background:var(--grey-1);z-index:10;padding:10px;border-radius: 5px;">

						<BuyButtonWrapper :productId="this.productId" @close="(() => { this.showBuyPopover = false} )" @mouseenter="this.stopCloseBuyPopoverTimer()" />

					</div>
				</div>



			</div>

			<div class="boxFooter link" style="margin-top:10px;" v-if="isLoggedIn && !this" @click.stop="buy()"><b>KÖP</b>
			</div>
		</div>
		<div v-else-if="this.debug">Product: {{ this.productId }} not found</div>
	</div>
</template>

<script>
import formatHelper from '../../helper/format-helper';
import { userMixin } from '../../mixins/userMixin';
import { productMixin } from '../../mixins/productMixin';
import { utilMixin } from '../../mixins/utilMixin';
import settings from '../../settings';
import { USER_STORE_ACTION } from '../../store/user-store';
//import ProductCellImage from './ProductCellImage.vue';
import ProductCellImageSquare from './ProductCellImageSquare.vue';
import BuyButtonWrapper from './product-details/BuyButtonWrapper.vue';



export default {
	name: "ProductCell",
	components: { ProductCellImageSquare, BuyButtonWrapper },
	mixins: [userMixin, productMixin, utilMixin],
	data() {
		return {
			showDetails: false,
			showCopied: false,
			over: false,
			canHover: false,
			showBuyPopover: false,
			alignRight: false,
			closeBuyPopoverTimer: null,
			
		};
	},
	props: {
		productId: Number,
		rowIndex: Number,
		parentTitle: String,
		favorite: Boolean,
		outlet: Boolean,
		canFavorite: {
			type: Boolean,
			default: false 
		}
	},
	computed: {

		stockModel(){


			var model = {origin: "", color: "", label: ""}

			var noInStockKey = null;

			// om vi har options
			if (this.product?.productOptionData?.count > 0){
				model.origin = "PO";
				noInStockKey = this.product?.productOptionData?.noInStockKey;
				
				
			} else if (this.product?.noInStockKey) {
				model.origin = "P";
				noInStockKey = this.product?.noInStockKey

			}

			

			

			if (!noInStockKey) {
				return null;
			}

			model.key = noInStockKey
			model.label = this.noInStockLabel(noInStockKey)
			model.labelShort = this.noInStockLabelShort(noInStockKey)

			return model;




		},

		filename(){
			// http://public2.boove.se.dev2/w2image/img11_66152c1588bb4242f9d6e326e16f2e8e_2_sample.jpg

			if (!this.product.image || this.product.image == ""){
				return null;
			}
			
			return settings.baseImagePath + this.product.image
		},

		title() {
			if (this.debug){
				return this.parentTitle + "\nProductCell, productId: " + this.productId + ", score: " + this.product?.entity?.search?.totalScore	+ "\nScore: " + this.product?.score 
			}
			return "";
		},
		product() {

			const product = this.$store.state.productStore.data.productList[this.productId]
			if (product) {
				product.urlKey = formatHelper.urlProductKey(product.name);
			}

			return product;

		},







	},
	watch: {
		showBuyPopover(value) {

			if (value) {


				this.alignRight = false;

				this.$nextTick(() => {

					const popover = this.$refs.productOptionPopover;
					const rect = popover.getBoundingClientRect();

					this.alignRight = rect.right > window.innerWidth;

					

				});
			}
		}
	},

	methods: {
		showProductDetails() {
			this.$emit("showProductDetails", this.product)
			//this.$router.push('/product/' + this.productId + "/" + this.product.urlKey)

		},
		test() {
			this.showDetails = true
		},
		buy() {

			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data });
		},

		copyArtNr() {

			this.copyToClipBoardNoAlert(this.product.artnr);

			this.showCopied = true;

			setTimeout(() => {
				this.showCopied = false;
			}, 1000);

		},

		startCloseBuyPopoverTimer(){
			

			if (!this.showBuyPopover){
				return;
			}

			
			this.closeBuyPopoverTimer = setTimeout(() => {
				this.showBuyPopover = false
			}, 1000);
		},

		stopCloseBuyPopoverTimer(){
			clearTimeout(this.closeBuyPopoverTimer);
		}
		

	},
	created(){
		this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches
	}
};
</script>

<style scoped>

div.box {
	background: white;
	min-height: 200px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 0px;
	border-radius: 2px;
	max-width:500px;
	/*position: relative;*/

}




div.boxHeader {
	display: flex;
	background: var(--grey-2);
	width: 100%;
	height: 30px;
	align-items: center;
	/*justify-content: center;*/
	color: lightcoral;
	display:none;
}

div.boxFooter{
	display: flex;
	background: var(--bg-message);
	width: 100%;
	height: 30px;
	align-items: center;
	justify-content: center;
	color: white;
	border-radius: 3px;
}

div.boxHeader {
	display: none;
}

div.boxPrice {

	
	padding: 0px;
	border-radius: 5px;
}

div.boxContent {

	overflow-y: scroll;
	max-height: 100px;
	width: 100%;
	border: 0px solid white;

}

div.boxSpacer {
	flex-grow: 1;
	background: transparent;
	width: 100%;
}

div.stock_SOME_IN_STOCK, div.stock_LOW_STOCK{
	background:var(--bg-warning-light); 
}

div.stock_IN_STOCK {
	background: var(--bg-ok-light);
}

div.stock_OUT_OF_STOCK {
	background: var(--bg-error-light);
}

.product {
	position: relative;
}

.productOptionPopover {
	position: absolute;
	top: 100%;
	left: 0;
	width: 600px;
	margin-left: 0px;
	margin-right: 0px;


}

.productOptionPopover.alignRight {
	left: auto;
	right: 0;
	margin-right: 0px;
	margin-left: 0px;
}

div#buyButtonWrapper {
	position: relative;

}




</style>